import { Navigate, useLocation } from "react-router-dom";
import { useEffect } from "react";
import {
  isTokenExpired,
  clearToken,
  startTokenTimer,
  stopTokenTimer,
  setupCrossTabLogout,
  setupActivityTracking,
  updateActivity,
} from "../Services/tokenUtils";

// Release A: user must set a new password before using the app.
function mustChangePassword() {
  try {
    const u = JSON.parse(localStorage.getItem("loggedUser") || "null");
    return !!u?.mustChangePassword;
  } catch {
    return false;
  }
}

export default function ProtectedRoute({ children }) {
  const expired = isTokenExpired();
  const location = useLocation();

  useEffect(() => {
    if (!expired) {
      // Start the token timer with activity-based refresh
      startTokenTimer();

      // Setup cross-tab logout functionality
      const crossTabCleanup = setupCrossTabLogout();

      // Setup activity tracking
      const activityCleanup = setupActivityTracking();

      // Mark initial activity
      updateActivity();

      // Cleanup on unmount
      return () => {
        stopTokenTimer(); // Use the proper stop function
        if (crossTabCleanup) crossTabCleanup();
        if (activityCleanup) activityCleanup();
      };
    }
  }, [expired]);

  if (expired) {
    // Full wipe — token, refreshToken, loggedUser, all md_*/categoryCache
    // caches, userPermissions. Leaving any of those behind exposed the next
    // user on the same device to stale data from the previous session.
    clearToken();
    return <Navigate to="/login" replace />;
  }

  // Lock the user to the change-password screen until the flag clears.
  if (mustChangePassword() && location.pathname !== "/change-password") {
    return <Navigate to="/change-password" replace />;
  }

  return children;
}
